import { HistoricoFechamentosInicial } from "../models/historicoFechamentosModel"
import type { HistoricoFechamentosModel } from "../models/historicoFechamentosModel"
import { HistoricoFechamentosActionsTypes } from "./historicoFechamentosActions"
import type { HistoricoFechamentosActions } from "./historicoFechamentosActions"

export function historicoFechamentosReducer(
    state: HistoricoFechamentosModel = HistoricoFechamentosInicial,
    action: HistoricoFechamentosActions
): HistoricoFechamentosModel {
    switch (action.type) {
        case HistoricoFechamentosActionsTypes.CARREGAR:
            return { ...state, fechamentos: action.payload }
        default:
            return state
    }
}
